import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Modal, Form, Input, Row, Col, Select, message, Spin } from 'antd';
import PropTypes from 'prop-types';
import UpdateConnectionPopup from './UpdateConnectionPopup';
import DeleteConnectionPopup from './DeleteConnectionPopup';
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { getNoofEmployee, getAnnualRevenue, IndustryData, getAllUsersData, getRating, getTriggerFiledforEntity, getCountryData, getStateData, getCityData } from '../../../Api/Services/CommonApiService'
import { FetchAllCustomerstatus, FetchAllAccount, massUpdateAccount, massDeleteAccount, FetchAllAccountType, FetchAllOwnership } from '../../../Api/Services/AccountApiService'
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Data from '../MassupdateJson/InLineEditFields.json'
import { ChangeOwnerIcon, SaveIcon, CancelIcon, DeleteIcon } from '../../../components/Icons/Icons';

const { Option } = Select;

const Popup = ({ updatePopup, setUpdatePopup, accountIDs, GetAll, popupType, action, assignOwner, pageType, setStates, successMessage }) => {
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const dispatch = useDispatch();
    const history = useHistory();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [rating, SetRating] = useState([])
    const [form] = Form.useForm();
    const [fieldValue, setFieldValue] = useState(1)
    const [accountData, setAccountData] = useState([])
    const [users, setUsers] = useState([])
    const [typeData, setTypeData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [industryData, setIndustryData] = useState([])
    const [ownerShipData, setOwnershipData] = useState([])
    const [companyId, setCompanyId] = useState()
    const [noofemployee, setNoofemployee] = useState([])
    const [field3, setField3] = useState()
    const [revenue, setRevenue] = useState([])
    const [errorData, setErrorData] = useState([])
    const [editAttributes, setEditAttributes] = useState([])
    const [allCountry, setAllCountry] = useState([])
    const [stateData, setStateData] = useState([])
    const [customerStatus, setCustomerStatus] = useState([])
    const [cityData, setCityData] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [uiReady, setUiReady] = useState(false)
    const [selectBoxes, setSelectBoxes] = useState([{ editedField: "accountOwner", editedValue: null }]);
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const fieldsToValidate = ['primaryEmail', 'secondaryEmail', 'email', 'mobile', 'assitantContactNumber', 'phone', 'website'];
    const isValidEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };
    const isValidPhoneNumber = (phoneNumber) => {
        const phonePattern = /^[0-9+-]+$/;
        return phonePattern.test(phoneNumber);
    };
    const isValidWebsite = (website) => {
        const websiteRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return websiteRegex.test(website);
    };
    const validateQuery = (query) => {
        if (!fieldsToValidate.includes(query.editedField)) {
            return true;
        }
        switch (query.editedField) {
            case 'primaryEmail':
            case 'secondaryEmail':
            case 'email':
                if (!isValidEmail(query.editedValue)) {
                    message.error(`Please enter a valid email address.`);
                    return false;
                }
                break;
            case 'mobile':
            case 'assitantContactNumber':
            case 'phone':
                if (!isValidPhoneNumber(query.editedValue)) {
                    message.error(`Invalid phone/mobile number`);
                    return false;
                }
                break;
            case 'website':
                if (!isValidWebsite(query.editedValue)) {
                    message.error(`Please enter a valid website url.`);
                    return false;
                }
                break;
            default:
                return false;
        }
        return true;
    };
    const validateQueryData = (queryData) => {
        return queryData.every(validateQuery);
    };
    function RequiredValidity(queryData) {
        for (let i = 0; i < queryData.length; i += 1) {
            const query = queryData[i];
            if (!query.editedField) {
                return { isValid: false, message: 'Incomplete query' };
            }
            if (query.visible !== "No") {
                if (
                    query.editedValue === undefined ||
                    query.editedValue === null ||
                    query.editedValue === ""
                ) {
                    return { isValid: false, message: 'Incomplete query' };
                }
            }
        }
        return { isValid: true };
    }
    const handleClose = () => {
        setUpdatePopup(false);
        if (pageType === "Listing") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
        if (popupType !== "Delete") {
            // setStates({ selectedRowKeys: [] })
        }
    }
    const handleChange = (value) => {
        setFieldValue(value)
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            const options = data.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                    < img src={option.account_profile} alt="profile" />
                                    :
                                    <span className="image_icon AccountIcon">
                                        {option.account_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{option.account_name}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                        <div>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.account_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            <p style={{ margin: 0 }}>{option.account_number}</p>
                        </div>
                    </div>
                </Option>));
            setAccountData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            setUsers(data)
        } catch (error) {
            message.error(error)
        }
    }
    const getAnnualRevenueData = async () => {
        try {
            const data = await getAnnualRevenue()
            const options = data.map((option, i) => (
                <Option value={option.annualRevenue} key={i}>
                    {option.annualRevenue}
                </Option>));
            setRevenue(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getRatingData = async () => {
        try {
            const data = await getRating()
            const options = data.map((option, i) => (
                <Option value={option.rating} key={i}>
                    {option.rating}
                </Option>));
            SetRating(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getNomEmployeeData = async () => {
        try {
            const data = await getNoofEmployee()
            const options = data.map((option, i) => (
                <Option value={option.nomOfEmployee} key={i}>
                    {option.nomOfEmployee}
                </Option>));
            setNoofemployee(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            const options = response.map((option) => (
                <Option key={option.countryId} value={option.country}>
                    {option.country}
                </Option>))
            setAllCountry(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function TypeDataApi() {
        try {
            const data = await FetchAllAccountType()
            let typeData;
            if (profile.roleName !== "Administrator") {
                typeData = data.filter((item) => item.accountTypeName === "Customer")
            } else {
                typeData = data
            }
            const options = typeData.map((option, i) => (
                <Option value={option.accountTypeId} key={i}>
                    {option.accountTypeName}
                </Option>));
            setTypeData(options)
        } catch (error) {
            message.error(error)
        }
    }
    async function IndustryDataApi() {
        try {
            const data = await IndustryData()
            setIndustryData(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getAllCustomerstatus = async () => {
        try {
            const data = await FetchAllCustomerstatus()
            const options = data.map((option, i) => (
                <Option value={option.customerStatus} key={i}>
                    {option.customerStatus}
                </Option>))
            setCustomerStatus(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function OwnerShipDataApi() {
        try {
            const data = await FetchAllOwnership()
            const options = data.map((option, i) => (
                <Option value={option.ownershipId} key={i}>
                    {option.ownershipName}
                </Option>));
            setOwnershipData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const onSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const formData = {
            accountIds: accountIDs,
            companyId,
            // country,
            // state,
            // city,
        }
        if (popupType === "Change Owner") {
            if (fieldValue === 1) {
                formData.accountOwner = field3;
            }
            const isAnyFieldUndefined = Object.values(formData).some(value => value === undefined);
            if (!isAnyFieldUndefined) {
                try {
                    const response = await massUpdateAccount(formData)
                    if (response.status === 200) {
                        if (action === "SingleChangeOwner") {
                            if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                                setErrorData(response.data);
                                setIsModalVisible1(true);
                                loadingRef.current = false;
                                setDelteClick(false)
                                dispatch(setEditCall(false))
                            }
                            else {
                                const isAutomation = response.data[0].message === AutomationMessage;
                                const isApproval = response.data[0].message === ApprovalMessage;
                                dispatch(setEditCall(false))
                                loadingRef.current = false;
                                setDelteClick(false)
                                if (isApproval) {
                                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                                } else if (isAutomation) {
                                    successMessage("Automation rule triggered", response.data[0].message);
                                } else {
                                    message.success(
                                        <span>
                                            Account <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                        </span>
                                    );
                                }
                                setUpdatePopup(false);
                                if (!isApproval && assignOwner !== field3) {
                                    history.push('/Home/sponsors');
                                }
                                if (assignOwner === field3) {
                                    GetAll()
                                }
                            }
                        }
                        else {
                            const allUpdatedSuccessfully = response.data.every(item =>
                                item.message === "Account Has Updated Successfully"
                            );
                            if (allUpdatedSuccessfully) {
                                dispatch(setEditCall(false))
                                if (pageType === "Listing") {
                                    setStates({
                                        selectedRows: [],
                                        selectedRowKeys: [],
                                    })
                                }
                                message.success("Data updated for selected records")
                                GetAll()
                                setUpdatePopup(false);
                                loadingRef.current = false;
                                setDelteClick(false)
                                return;
                            }
                            loadingRef.current = false;
                            setDelteClick(false)
                            dispatch(setEditCall(false))
                            setErrorData(response.data);
                            setIsModalVisible1(true);
                        }
                    }
                } catch (error) {
                    message.error(error);
                    loadingRef.current = false;
                    setDelteClick(false)
                }
            } else {
                loadingRef.current = false;
                setDelteClick(false)
                message.error("Field is Empty");
            }
        }
        if (popupType === "Bulk Update") {
            const validation = RequiredValidity(selectBoxes);
            if (!validation.isValid) {
                message.error(validation.message);
                return;
            }
            if (validateQueryData(selectBoxes)) {
                const flatFields = selectBoxes.reduce((acc, item) => {
                    const { editedField, editedValue, visible } = item;
                    if (!editedField) return acc;
                    if (visible === "No") {
                        acc[editedField] = editedValue;
                        return acc;
                    }
                    if (editedValue != null) {
                        acc[editedField] = editedValue;
                    }
                    return acc;
                }, {});
                Object.assign(formData, flatFields);
                try {
                    const response = await massUpdateAccount(formData)
                    if (response.status === 200) {
                        const allUpdatedSuccessfully = response.data.every(item =>
                            item.message === "Account Has Updated Successfully"
                        );
                        if (allUpdatedSuccessfully) {
                            dispatch(setEditCall(false))
                            if (pageType === "Listing") {
                                setStates({
                                    selectedRows: [],
                                    selectedRowKeys: [],
                                })
                            }
                            message.success("Data updated for selected records")
                            GetAll()
                            setUpdatePopup(false);
                            loadingRef.current = false;
                            setDelteClick(false)
                            return;
                        }
                        loadingRef.current = false;
                        setDelteClick(false)
                        dispatch(setEditCall(false))
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                    }
                } catch (error) {
                    message.error(error);
                    loadingRef.current = false;
                    setDelteClick(false)
                }
            }
        }
    }
    const HandleIsModalVisible = (value) => {
        setUpdatePopup(value)
        setIsModalVisible(value)
    }
    async function onDelete() {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const payload = {
            accountIds: accountIDs
        }
        try {
            const response = await massDeleteAccount(payload);
            if (response.status === 200) {
                if (popupType === "Delete") {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible(true);
                        dispatch(setEditCall(false))
                        loadingRef.current = false;
                        setDelteClick(false)
                    } else {
                        const isAutomation = response.data[0].entityMessage === AutomationMessage;
                        const isApproval = response.data[0].entityMessage === ApprovalMessage;
                        dispatch(setEditCall(false))
                        loadingRef.current = false;
                        setDelteClick(false)
                        if (isApproval) {
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                        } else if (isAutomation) {
                            successMessage("Automation rule triggered", response.data[0].entityMessage);
                        } else {
                            message.success(
                                <span>
                                    Account <strong>{response?.data?.[0]?.entityName}</strong> has been deleted successfully
                                </span>
                            );
                        }
                        history.push('/Home/sponsors')
                        setUpdatePopup(false);
                    }
                } else {
                    const allUpdatedSuccessfully = response.data.every(item =>
                        item.entityMessage === "Account Has Deleted Successfully"
                    );
                    if (allUpdatedSuccessfully) {
                        dispatch(setEditCall(false))
                        message.success(`${accountIDs.length} records deleted successful`);
                        GetAll();
                        setStates({
                            selectedRows: [],
                            selectedRowKeys: [],
                        })
                        setUpdatePopup(false);
                        loadingRef.current = false;
                        setDelteClick(false)
                        return;
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    dispatch(setEditCall(false))
                    setErrorData(response.data);
                    setIsModalVisible(true);
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            message.error(error)
        }
    }
    const handleAccountOwnerchange = (value) => {
        setField3(value)
    }
    const getRefreshtheTable = () => {
        setUpdatePopup(false);
        if (popupType === "Bulk Delete") {
            GetAll();
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        } if (popupType === "Delete") {
            history.push('/Home/sponsors')
        }
    }
    async function Triggerfields() {
        try {
            const response = await getTriggerFiledforEntity("Account")
            const removeFields = ["accountName", "accountNumber"];
            const filteredAttributes = response.filter(
                item => !removeFields.includes(item.filedValue)
            );
            setEditAttributes(filteredAttributes)
        } catch (error) {
            message.error(error)
        }
    }
    // const getFieldIndex = (formData, fieldName) => {
    //     return formData.find(item => item.editedField === fieldName);
    // };
    const handleViewChange = async (index, fieldName, value, key, currecnyData, option) => {
        let updatedFormData = [...selectBoxes];
        if (fieldName === "editedField") {
            const oldData = updatedFormData[index].editedField;
            if (oldData === "accountType") {
                updatedFormData = updatedFormData.filter((item, idx) => {
                    if (idx === 0) return true;
                    return !["customerStatus", "industry", "accountOwner", "parentOrganization", "rating"].includes(item.editedField);
                });
            }
            updatedFormData[index] = {
                ...updatedFormData[index],
                editedField: value,
                editedValue: null,
                Key: key,
                Currency: currecnyData
            };

            if (value === "country" || value === "state" || value === "city" || value === "customerStatus" || value === "accountType" || value === "street" || value === "postcode") {
                const countryField = {
                    editedField: "country",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                const stateField = {
                    editedField: "state",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                const cityField = {
                    editedField: "city",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                const streetField = {
                    editedField: "street",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                if (value === "country") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "accountType" && item.editedField !== "customerStatus"
                    );
                    updatedFormData = updatedFormData.map(item =>
                        (item.editedField === "state" || item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode")
                            ? {
                                ...item, editedField: item.editedField, editedValue: null
                            }
                            : item
                    );
                    setStateData([])
                    setCityData([])
                }
                if (value === "state") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== 'city' && item.editedField !== "street" && item.editedField !== "postcode" && item.editedField !== "accountType" && item.editedField !== "customerStatus"
                    );
                    updatedFormData.splice(index, 0, countryField);

                    setStateData([])
                    setCityData([])
                }
                if (value === "city") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "street" && item.editedField !== "postcode" && item.editedField !== "accountType" && item.editedField !== "customerStatus"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField);
                }
                if (value === "street") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "postcode" && item.editedField !== "accountType" && item.editedField !== "customerStatus"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField, cityField);
                }
                if (value === "postcode") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street" && item.editedField !== "accountType" && item.editedField !== "customerStatus"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField, cityField, streetField);
                }
                if (value === "accountType") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street" && item.editedField !== "postcode"
                    );
                    updatedFormData = updatedFormData.map(item =>
                        (item.editedField === "customerStatus")
                            ? {
                                ...item, editedField: item.editedField, editedValue: null
                            }
                            : item
                    );
                }
                if (value === "customerStatus") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street" && item.editedField !== "postcode"
                    );
                    const hasCountry = updatedFormData.some(item => item.editedField === "accountType");
                    const inserts = [];
                    if (!hasCountry) {
                        inserts.push({
                            editedField: "accountType",
                            editedValue: null,
                            Key: null,
                            Currency: null
                        });
                    }
                    if (inserts.length > 0) {
                        updatedFormData.splice(index, 0, ...inserts);
                        index += inserts.length;
                    }
                }
                // if (value === "accountOwner") {
                //     const hasCountry = updatedFormData.some(item => item.editedField === "accountOwner");
                //     const inserts = [];
                //     if (!hasCountry) {
                //         inserts.push({
                //             editedField: "accountType",
                //             editedValue: null,
                //             Key: null,
                //             Currency: null
                //         });
                //     }
                //     if (inserts.length > 0) {
                //         updatedFormData.splice(index, 0, ...inserts);
                //         index += inserts.length;
                //     }
                // }
            } else {
                updatedFormData = updatedFormData.filter(
                    item => !["country", "state", "city", "street", "postcode", "accountType", "customerStatus"].includes(item.editedField)
                );
            }
        }
        else {
            const editedFieldType = updatedFormData[index]?.editedField;
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                Key: key
            };
            if (editedFieldType === "country") {
                try {
                    const response = await getStateData(option.key)
                    setStateData(response)
                    setCityData([])
                    const existingIndex = updatedFormData.find(
                        item => item.editedField === "state"
                    );
                    const existingIndex2 = updatedFormData.find(
                        item => item.editedField === "city"
                    );
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "state") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "state",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex2) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "city") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "city",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "state" || item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setCityData([])
                    setStateData([])
                    message.error(error)
                }
            }
            else if (editedFieldType === "state") {
                try {
                    const response = await getCityData(option.key)
                    setCityData(response)
                    const existingIndex2 = updatedFormData.find(
                        item => item.editedField === "city"
                    );
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex2) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "city") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "city",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setCityData([])
                    message.error(error)
                }
            }
            else if (editedFieldType === "city") {
                try {
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    message.error(error)
                }
            }
            else if (editedFieldType === "street") {
                try {
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    message.error(error)
                }
            }
            else if (editedFieldType === "accountType") {
                if (option.children === "Customer") {
                    const existingIndex = updatedFormData.find(
                        item => item.editedField === "customerStatus"
                    );
                    if (existingIndex) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "customerStatus") {
                                return {
                                    ...item,
                                    editedValue: "Prospective Customer",
                                };
                            }
                            return item;
                        });
                    } else {
                        updatedFormData.push({
                            editedField: "customerStatus",
                            editedValue: "Prospective Customer",
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }

                else if (option.children === "Competitor") {
                    const competitorFields = [
                        { field: "industry", value: 23 },
                        { field: "customerStatus", value: null },
                        { field: "accountOwner", value: null },
                        { field: "parentOrganization", value: null },
                        { field: "rating", value: null }
                    ];

                    competitorFields.forEach(({ field, value }) => {
                        const existingIndex = updatedFormData.find(
                            item => item.editedField === field
                        );

                        if (existingIndex) {
                            updatedFormData = updatedFormData.filter(item => item.editedField !== field);
                            updatedFormData.push({
                                editedField: field,
                                editedValue: value,
                                Key: null,
                                Currency: null,
                                visible: "No"
                            });
                        } else {
                            updatedFormData.push({
                                editedField: field,
                                editedValue: value,
                                Key: null,
                                Currency: null,
                                visible: "No"
                            });
                        }
                    });
                }

                else {
                    const extraFields = ["industry", "customerStatus", "accountOwner", "parentOrganization", "rating"];

                    extraFields.forEach(field => {
                        const existingIndex = updatedFormData.find(
                            item => item.editedField === field
                        );

                        if (existingIndex) {
                            updatedFormData = updatedFormData.filter(item => item.editedField !== field);
                            updatedFormData.push({
                                editedField: field,
                                editedValue: null,
                                Key: null,
                                Currency: null,
                                visible: "No"
                            });
                        } else {
                            updatedFormData.push({
                                editedField: field,
                                editedValue: null,
                                Key: null,
                                Currency: null,
                                visible: "No"
                            });
                        }
                    });
                }
            }
        }
        setSelectBoxes(updatedFormData);
    };
    const getAvailableOptions = (currentIndex) => {
        const selectedValues = selectBoxes.filter(box => box.visible !== "No").map(box => box.editedField).filter(value => value !== undefined);
        return editAttributes.filter(option => !selectedValues.includes(option.filedValue) || selectBoxes[currentIndex].editedField === option.filedValue);
    };
    function getFieldTypeByValue(fieldValue) {
        const field = editAttributes.find(item => item.filedValue === fieldValue);
        return field ? field.FieldType : null;
    }
    const getUserDetail = async () => {
        if (action === "SingleChangeOwner") {
            setField3(assignOwner)
            form.setFieldsValue({
                accountowner: assignOwner
            });
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (profile.department === "Sales") {
                setField3(profile.userId)
                form.setFieldsValue({
                    accountowner: profile.userId
                });
            }
        }
        setCompanyId(profile.companyId)
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            AccountApi(),
            Triggerfields(),
            getCountry(),
            getAllCustomerstatus(),
            getRatingData(),
            getAnnualRevenueData(),
            getNomEmployeeData(),
            IndustryDataApi(),
            TypeDataApi(),
            OwnerShipDataApi(),
            getUserDetail()
        ])
        setUiReady(true)
    };
    const fetchAll1 = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            getUserDetail()
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (updatePopup) {
            if (popupType === "Bulk Update") {
                fetchAll()
            }
            else if (popupType === "Change Owner") {
                fetchAll1()
            }
            else {
                setUiReady(true)
            }
        }
    }, [updatePopup])
    return (
        <>
            <Modal
                title={popupType}
                open={updatePopup}
                onCancel={handleClose}
                // centered
                maskClosable={false}
                footer={uiReady ? [
                    <div>
                        {popupType === "Bulk Update" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small">
                                    <CancelIcon />Cancel
                                </Button>
                                <Button className='btn-add_new button_colors' onClick={onSubmit} size="small" loading={deleteClick} disabled={deleteClick} >
                                    {!deleteClick && <SaveIcon />}Update
                                </Button>
                            </>
                        }
                        {popupType === "Change Owner" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small" >
                                    <CancelIcon />Cancel
                                </Button>
                                <Button htmlType="submit" size="small" className='btn-add_new button_colors' onClick={onSubmit} loading={deleteClick} disabled={deleteClick} >
                                    {!deleteClick && <ChangeOwnerIcon />}Change Owner
                                </Button>
                            </>
                        }

                        {popupType.includes("Delete") &&
                            <>
                                <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                    <CancelIcon /> Cancel
                                </Button>
                                <Button htmlType="submit" size="small" onClick={onDelete} className='red-button' loading={deleteClick} disabled={deleteClick} >
                                    {!deleteClick && <DeleteIcon />}{popupType}
                                </Button>
                            </>}
                    </div>
                ] : false}
            // width={600}
            >
                {uiReady ? <>
                    {popupType === "Bulk Update" &&
                        (editAttributes.length > 0 ?
                            <AddUser>
                                <div className="user-info-form">
                                    <BasicFormWrapper>
                                        <Form style={{ width: '100%' }} form={form} name="AccountMassUpdate" >
                                            {selectBoxes.filter((item) => item?.visible !== "No").map((selectbox, index) => {
                                                const filedType = getFieldTypeByValue(selectbox.editedField)
                                                const accountTypeValue = selectBoxes[0]?.editedValue;
                                                return (
                                                    <Row gutter={30} style={{ marginBottom: 20, marginTop: 20, padding: "0px 20px" }}>
                                                        <Col span={10}>
                                                            <Form.Item >
                                                                <Select style={{ width: '100%' }}
                                                                    placeholder="Select Field"
                                                                    showSearch
                                                                    optionFilterProp="children"
                                                                    filterOption={(input, option) =>
                                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                    value={selectbox.editedField}
                                                                    onChange={(record, option) => {
                                                                        const Key = option.FieldType
                                                                        const currecnyData = option.FieldData
                                                                        handleViewChange(index, 'editedField', record, Key, currecnyData);
                                                                    }}
                                                                    disabled={index !== 0}
                                                                >
                                                                    {getAvailableOptions(index).map((option, idx) => (
                                                                        <Option value={option.filedValue} key={idx} FieldType={option.FieldType} FieldData={option.currencyType}>
                                                                            {option.fieldLable}
                                                                        </Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={14}>
                                                            <Form.Item key={index}>
                                                                {filedType === 'Drop Down' ? (
                                                                    <Select placeholder="Select Value"
                                                                        showSearch
                                                                        style={{ width: "100%" }}
                                                                        optionFilterProp="children"
                                                                        {...(selectbox.editedField === "accountOwner" || selectbox.editedField === "parentOrganization"
                                                                            ? { optionLabelProp: "label" } : {})}
                                                                        filterOption={(input, option) =>
                                                                            (selectbox.editedField === "accountOwner" || selectbox.editedField === "parentOrganization")
                                                                                ? (() => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                })()
                                                                                : option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        disabled={index === 1 &&
                                                                            selectbox.editedField === "customerStatus" &&
                                                                            accountTypeValue !== 1}
                                                                        name="editedValue"
                                                                        value={selectbox.editedValue}
                                                                        onChange={(value, option) => {
                                                                            handleViewChange(index, 'editedValue', value, filedType, selectbox.Currency, option);
                                                                        }}
                                                                    >
                                                                        {(selectbox.editedField === "accountOwner") &&
                                                                            users.filter(item => item.department === "Sales").map((option, i) => (
                                                                                <Option value={option.userId}
                                                                                    label={(
                                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                            <div className='Div_flex2'>
                                                                                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                        < img src={option.profilePic} alt="profile" />
                                                                                                        :
                                                                                                        <span className="image_icon UserIcon">
                                                                                                            {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                        </span>
                                                                                                    }
                                                                                                    <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                    key={i}>
                                                                                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                                        <div>
                                                                                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }</div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                            <p style={{ margin: 0 }}>{option.username}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))
                                                                        }
                                                                        {selectbox.editedField === "industry" &&
                                                                            industryData.map((option, i) => (
                                                                                <Option value={option.industryId} key={i}>
                                                                                    {option.industryName}
                                                                                </Option>))}
                                                                        {selectbox.editedField === "ownership" &&
                                                                            <>
                                                                                {ownerShipData}
                                                                            </>}
                                                                        {selectbox.editedField === "accountType" &&
                                                                            <>
                                                                                {typeData}
                                                                            </>}
                                                                        {selectbox.editedField === "parentOrganization" &&
                                                                            <>
                                                                                {accountData}
                                                                            </>}
                                                                        {selectbox.editedField === "country" &&
                                                                            <>
                                                                                {allCountry}
                                                                            </>}
                                                                        {selectbox.editedField === "state" &&
                                                                            <>
                                                                                {stateData?.map((option) => (
                                                                                    <Option key={option.stateId} value={option.state}>
                                                                                        {option.state}
                                                                                    </Option>
                                                                                ))}
                                                                            </>}
                                                                        {selectbox.editedField === "city" &&
                                                                            <>
                                                                                {cityData?.map((option) => (
                                                                                    <Option key={option.cityId} value={option.city}>
                                                                                        {option.city}
                                                                                    </Option>
                                                                                ))}
                                                                            </>}
                                                                        {selectbox.editedField === "annualRevenue" &&
                                                                            <>
                                                                                {revenue}
                                                                            </>}
                                                                        {selectbox.editedField === "nomOfEmployees" &&
                                                                            <>
                                                                                {noofemployee}
                                                                            </>}
                                                                        {selectbox.editedField === "rating" &&
                                                                            <>
                                                                                {rating}
                                                                            </>}
                                                                        {selectbox.editedField === "customerStatus" &&
                                                                            <>
                                                                                {customerStatus}
                                                                            </>}

                                                                    </Select>
                                                                ) : filedType === 'Free Text' || filedType === 'Numbers' ? (
                                                                    (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                        name="editedValue"
                                                                        value={selectbox.editedValue}
                                                                        onChange={(e) => {
                                                                            handleViewChange(index, 'editedValue', e.target.value, filedType, selectbox.Currency);
                                                                        }} />
                                                                    ))
                                                                    : ""
                                                                }
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                )
                                            })}
                                        </Form>
                                    </BasicFormWrapper>
                                </div>
                            </AddUser> :
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "120px" }}>
                                <Spin />
                            </div>)
                    }
                    {popupType === "Change Owner" &&
                        <AddUser>
                            <div className="user-info-form">
                                <BasicFormWrapper>
                                    <Form style={{ width: '100%' }} form={form} name="Assignto" >

                                        <Row gutter={30} style={{ marginBottom: 20, marginTop: 20 }}>
                                            <Col span={10}>
                                                <Form.Item>
                                                    <Select style={{ width: '100%' }}
                                                        placeholder="Select Field"
                                                        showSearch
                                                        disabled
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        value={fieldValue}
                                                        onChange={handleChange}
                                                    >
                                                        {Data.Account !== undefined && Data.Account?.map((option, key) => (
                                                            <Option key={key} value={option.id}>
                                                                {option.filed}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={14}>
                                                {fieldValue === 1 &&
                                                    <Form.Item name="accountowner" id="accountowner" >
                                                        <Select style={{ width: '100%' }}
                                                            placeholder="Select Account Owner"
                                                            showSearch optionLabelProp="label"
                                                            filterOption={(input, option) => {
                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                    const username = String(usernameElement.props.children);
                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                }
                                                                return false;
                                                            }
                                                            }
                                                            onChange={handleAccountOwnerchange}
                                                        >
                                                            {users.filter(item => item.department === "Sales").map((option, i) => (
                                                                <Option value={option.userId}
                                                                    label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                        < img src={option.profilePic} alt="profile" />
                                                                                        :
                                                                                        <span className="image_icon UserIcon">
                                                                                            {option.firstName.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }
                                                                                    <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    key={i}>
                                                                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                        <div>
                                                                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                :
                                                                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                    {option.firstName.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                            }</div>
                                                                        <div>
                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                            <p style={{ margin: 0 }}>{option.username}</p>
                                                                        </div>
                                                                    </div>
                                                                </Option>))}
                                                        </Select>
                                                    </Form.Item>}
                                            </Col>
                                        </Row>
                                    </Form>
                                </BasicFormWrapper>
                            </div>
                        </AddUser>
                    }
                    {popupType.includes("Delete") &&
                        < div >
                            <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                {popupType === "Bulk Delete" && <p>Are you sure you want to delete the selected accounts?</p>}
                                {popupType === "Delete" && <p>Are you sure you want to delete?</p>}
                            </div>
                        </div>
                    }
                </> :
                    <div className="spin" style={{ height: "250px" }}>
                        <Spin />
                    </div>}
            </Modal >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page={pageType === "Listing" ? "DetailsError" : "Details"} type="Account" getCallBack={getRefreshtheTable} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page={popupType === "Bulk Delete" ? "DetailsError" : "Details"} type="Account" getCallBack={getRefreshtheTable} />}
        </>
    );
};

Popup.propTypes = {
    successMessage: PropTypes.func.isRequired,
    updatePopup: PropTypes.bool.isRequired,
    setUpdatePopup: PropTypes.func.isRequired,
    accountIDs: PropTypes.array.isRequired,
    GetAll: PropTypes.func.isRequired,
    setStates: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    pageType: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    assignOwner: PropTypes.number.isRequired,
};

export default Popup;
